import apiClient from './apiClient';

/**
 * Service for System Settings.
 */
const settingsService = {
    async getSettings() {
        return await apiClient.get('/settings');
    },

    async updateSettings(settings) {
        return await apiClient.put('/settings', settings);
    }
};

export default settingsService;
